import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { TabsComponent } from "../../../../../../Components";
import { ViewTypesEnum } from "../../../../../../Enums";
import { PropertiesUnitsSale } from "./PropertiesUnitsSale";
import { PropertiesUnitsLease } from "./PropertiesUnitsLease";
import { useUnitValidationContext } from "../../../../../../Contexts/UnitValidationContext/UnitValidationContext";
import { MessageConfirmDialog } from "../../../../../../SharedComponents";
import { GlobalHistory } from "../../../../../../Helper";

export const PropertiesUnitComponent = ({ propertyWithPolicy, propertyId }) => {
  const parentTranslationPath = "UnitsView";
  const translationPath = "";
  const { t } = useTranslation(parentTranslationPath);
  const { toggleUnitValidationDialog, onCloseClicked } =
    useUnitValidationContext();
  const [viewType, setViewType] = useState(ViewTypesEnum.cards.key);
  const [isMissingInfoMSGOpen, setIsMissingInfoMSGOpen] = useState(false);
  const [operationType, setOperationType] = useState("Sale");
  const [activeTab, setActiveTab] = useState(0);
  const tabsData = [
    {
      label: t(`sale`),
      component: PropertiesUnitsSale,
    },
    {
      label: t(`lease`),
      component: PropertiesUnitsLease,
    },
  ];
  const { setSelected, setState, setIsFromProperty , selected , state  } =
    useUnitValidationContext();

  const onTabChanged = (e, tabIndex) => {
    setActiveTab(tabIndex);
    if (tabIndex === 0) {
      setOperationType("Sale");
    } else if (tabIndex === 1) {
      setOperationType("Lease");
    }
  };

  const onTypeChanged = useCallback((activeType) => {
    setViewType(activeType);
  }, []);

  const createNewUnitHandler = useCallback(
    (activeType) => {
      if (
        propertyWithPolicy?.property?.property_lock &&
        propertyWithPolicy?.property?.property_lock === "Yes"
      ) {
        setIsMissingInfoMSGOpen(true);
      } else {
        setIsMissingInfoMSGOpen(false);
        let callback = null;
        if (operationType === "Sale") {
          callback = () =>
            GlobalHistory.push("/home/units-sales/add?formType=1");
        } else if (operationType === "Lease") {
          callback = () =>
            GlobalHistory.push("/home/units-lease/add?formType=1");
        }
        toggleUnitValidationDialog(callback);

        setState({
          id: "propertyName",
          value: propertyWithPolicy?.property?.property_name,
        });

        setSelected({
          id: "propertyName",
          value: {
            Ids: propertyId,
            property_name: propertyWithPolicy?.property?.property_name,
            name: propertyWithPolicy?.property?.property_name,
            id: propertyId,
            ...propertyWithPolicy.property,
          },
        });
        setState({
          id: "operationType",
          value: operationType === "Sale" ? "Sale" : "Lease",
        });
        setSelected({
          id: "operationType",
          value:
            operationType === "Sale"
              ? {
                  lookupItemId: 430,
                  lookupItemName: "Sale",
                }
              : {
                  lookupItemId: 431,
                  lookupItemName: "Rent",
                },
        });
        setIsFromProperty((item) => ({
          ...item,
          propertyName: true,
          operationType: true,
        }));
      }
    },
    [propertyWithPolicy, propertyId, operationType]
  );
  return (
    <>
      <div className="property-units-wrapper mt-3">
        <TabsComponent
          data={tabsData}
          labelInput="label"
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          themeClasses="theme-curved"
          currentTab={activeTab}
          onTabChanged={onTabChanged}
          dynamicComponentProps={{
            operationType,
            onTypeChanged,
            viewType,
            parentTranslationPath,
            translationPath,
            createNewUnitHandler,
          }}
        />
        {isMissingInfoMSGOpen && (
          <MessageConfirmDialog
            isDialogOpen={isMissingInfoMSGOpen}
            theme="warning"
            content={{
              heading: "property-is-locked",
              body: t(
                `${translationPath}this-property-is-locked-and-new-units-cannot-be-added-please-contact-your-system-administrator-or-lead-owner-team-lead-for-further-assistance`
              ),
            }}
            cancelButton={{
              label: "cancel",
              handler: () => {
                setIsMissingInfoMSGOpen(false);
              },
            }}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
          />
        )}
      </div>
    </>
  );
};

PropertiesUnitComponent.propTypes = {
  parentTranslationPath: PropTypes.string.isRequired,
  translationPath: PropTypes.string.isRequired,
};
